export default "__VITE_ASSET__BFRS63xK__"